import { useEffect } from "react";

import { PreloadedQuery } from "react-relay";

import { pricingPageRelayQuery } from "@/__generated_contentful__/pricingPageRelayQuery.graphql";
import { PricingContentContextProviderRelay } from "@/components/wpl/pricing/src/pricing-content-context.tsx";
import {
    SoftwareRovoPricingPageTemplate,
    SoftwareRovoPricingPageTemplateProps
} from "@/templates/software/rovo/pricing/software-rovo-pricing-page/src";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";
import { PricingContent } from "@/utils/pricing-queries/get-pricing-content.ts";

export type SoftwareRovoPricingPageProps =
    SoftwareRovoPricingPageTemplateProps & {
        pricingContent?: PricingContent;
        queryRef?: PreloadedQuery<pricingPageRelayQuery>;
    };

export const SoftwareRovoPricingPageRelay = (
    props: SoftwareRovoPricingPageProps
) => {
    useEffect(() => {
        checkFeatureFlagGate(featureFlags.cpapiwdPricingAll);
    }, []);

    return (
        <div data-testid="rovo-pricing-page">
            <PricingContentContextProviderRelay
                productId="rovo"
                pricingContent={props.pricingContent}
                queryRef={props.queryRef}
            >
                <SoftwareRovoPricingPageTemplate {...props} />
            </PricingContentContextProviderRelay>
        </div>
    );
};
